<template>
	<div style="
      background-color: whitesmoke;
      padding: 10px;
      margin-bottom: 10px;
      border: 1px solid #eee;
    ">
		<div style="padding: 10px">
			<div style="display: flex">
				<div style="flex-basis: 200px; text-align: left">
					<label>پارامترهای گزارش:</label>
				</div>
				<div style="flex-grow: 2; text-align: right; padding-right: 5px">
					<report-parameters />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ReportHeader",
		props: {
			// modelValue: {
			//   type: Object,
			// },
		},
		emits: ["update:modelValue"],
		data() {
			return {
				localData: {
					name: "",
				},
			}
		},
		computed: {},
		mounted() { },
		methods: {},
	}
</script>

<style></style>